export const INDUSTRY_TYPES = [
  'Real Estate',
  'Transportation',
  'Technology',
  'Healthcare',
  'Finance',
  'Education',
  'Retail',
  'Manufacturing',
  'Construction',
  'Consulting',
  'Other',
];

export const DEFAULT_COLORS = [
  { name: 'Blue', primary: '#1976D2', secondary: '#E3F2FD', text: '#FFFFFF' },
  { name: 'Green', primary: '#2E7D32', secondary: '#E8F5E9', text: '#FFFFFF' },
  { name: 'Orange', primary: '#ED6C02', secondary: '#FFF3E0', text: '#FFFFFF' },
  { name: 'Purple', primary: '#7B1FA2', secondary: '#F3E5F5', text: '#FFFFFF' },
  { name: 'Red', primary: '#D32F2F', secondary: '#FFEBEE', text: '#FFFFFF' },
  { name: 'Teal', primary: '#00796B', secondary: '#E0F2F1', text: '#FFFFFF' },
];
